import { DateLocalizer } from "react-big-calendar";

interface CalendarHeaderProps {
	date: string;
	localizer: DateLocalizer;
}
export default function CalendarHeader({ date, localizer }: CalendarHeaderProps) {
	const label = localizer.format(new Date(date), `D ddd`);
	const isToday = new Date(date).toDateString() === new Date().toDateString();

	if (isToday) {
		return <div className="rounded-full font-medium text-sm text-primary-700">{label}</div>;
	}
	return <div className="rounded-full font-thin text-sm text-gray-700">{label}</div>;
}
